/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:a14ee251-62a4-47b2-a008-56761532cbc8",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_dAEK6Y13N",
    "aws_user_pools_web_client_id": "5qgnb3gocqgrbrnpeb0v88pnc6",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://y5qdums5qbfsrnup5hlh3nd534.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "slideshowstorage130839-dev",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
